import { PROVIDER_DIRECTORY_URL } from '../constants/routes.constants';
import { MENU_ITEM_TITLE_KEYS } from './constants/menu-item-title-keys.constants';
import { mainFeatures, ROUTES, SUB_MENU_ITEMS } from './menu-items';
import { RouteInfo } from './sidebar.metadata';

export { mainFeatures, SUB_MENU_ITEMS };

/** Dropdowns de sección exclusivos del menú v2 (VDS-3070). */
export enum MenuSectionFeature {
  operationalDropdown = 'operationalDropdown',
  financialDropdown = 'financialDropdown',
  securityDropdown = 'securityDropdown',
  configurationsDropdown = 'configurationsDropdown',
}

function cloneRoute(route: RouteInfo): RouteInfo {
  return {
    ...route,
    submenu: route.submenu ? route.submenu.map((item) => ({ ...item })) : [],
  };
}

function cloneRoutes(source: Record<string, RouteInfo>): Record<string, RouteInfo> {
  const result: Record<string, RouteInfo> = {};
  Object.keys(source).forEach((key) => {
    result[key] = cloneRoute(source[key]);
  });
  return result;
}

const routesV2 = cloneRoutes(ROUTES);

routesV2[MenuSectionFeature.operationalDropdown] = {
  path: '',
  title: MENU_ITEM_TITLE_KEYS.operational,
  icon: 'chat',
  class: 'has-arrow',
  extralink: false,
  submenu: [],
} as RouteInfo;

routesV2[MenuSectionFeature.financialDropdown] = {
  path: '',
  title: MENU_ITEM_TITLE_KEYS.financial,
  icon: 'payments',
  class: 'has-arrow',
  extralink: false,
  submenu: [],
} as RouteInfo;

routesV2[MenuSectionFeature.securityDropdown] = {
  path: '',
  title: MENU_ITEM_TITLE_KEYS.security,
  icon: 'shield',
  class: 'has-arrow',
  extralink: false,
  submenu: [],
} as RouteInfo;

routesV2[MenuSectionFeature.configurationsDropdown] = {
  path: '',
  title: MENU_ITEM_TITLE_KEYS.configurations,
  icon: 'settings',
  class: 'has-arrow',
  extralink: false,
  submenu: [],
} as RouteInfo;

routesV2[mainFeatures.buildings] = {
  ...routesV2[mainFeatures.buildings],
  title: MENU_ITEM_TITLE_KEYS.myCommunity,
};

routesV2[mainFeatures.buildingsAdmin] = {
  ...routesV2[mainFeatures.buildingsAdmin],
  title: MENU_ITEM_TITLE_KEYS.myCommunity,
};

routesV2[mainFeatures.registrations] = {
  ...routesV2[mainFeatures.registrations],
  title: MENU_ITEM_TITLE_KEYS.approveUsers,
};

routesV2[mainFeatures.ticketsV2] = {
  ...routesV2[mainFeatures.ticketsV2],
  title: MENU_ITEM_TITLE_KEYS.ticketsV2,
};

routesV2[mainFeatures.accountStatements] = {
  ...routesV2[mainFeatures.accountStatements],
  title: MENU_ITEM_TITLE_KEYS.accountStatements,
};

routesV2[mainFeatures.munilyProviders] = {
  ...routesV2[mainFeatures.munilyProviders],
  title: MENU_ITEM_TITLE_KEYS.integrations,
};

/** Re-enlaza submenús legacy al objeto canónico v2 (títulos renombrados). */
function rewireSubmenu(dropdownKey: string, submenuFeatures: string[]): void {
  const dropdown = routesV2[dropdownKey];
  if (!dropdown) {
    return;
  }
  dropdown.submenu = submenuFeatures.map((feature) => routesV2[feature]).filter(Boolean);
}

rewireSubmenu(mainFeatures.administrativeDropdown, [
  mainFeatures.users,
  mainFeatures.registrations,
  mainFeatures.administration,
  mainFeatures.areas,
  mainFeatures.buildingsAdmin,
]);

rewireSubmenu(mainFeatures.administrativeMacroDropdown, [mainFeatures.usersMacro, mainFeatures.areasMacro]);

rewireSubmenu(mainFeatures.controlAccess, [mainFeatures.doorOpeningAdmin]);

/** Tabla de rutas del menú v2 (clon independiente de v1; Tickets en `/app/tickets`). */
export const ROUTES_V2: Record<string, RouteInfo> = routesV2;
